import { HomeState } from '@/modules/home/core/state/home.state';
import { FetchMeUser } from '@/modules/home/core/state/home.actions';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, first, map, Observable, tap } from 'rxjs';
import {
  hasEnabledPermission,
  MeProfile,
} from '../services/profile/me-profile.model';

@Injectable({
  providedIn: 'root',
})
export class LprBlacklistGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(HomeState.getMe).pipe(
      tap((me) => {
        if (!me) {
          this.store.dispatch(new FetchMeUser());
        }
      }),
      filter((me): me is MeProfile => !!me),
      first(),
      map((me) => {
        const hasAccess = hasEnabledPermission(me, 'can_see_lpr_blacklist');

        if (!hasAccess) {
          this.router.navigate(['/minhas-cameras']);
          return false;
        }

        return true;
      }),
    );
  }
}
